module.exports = __webpack_public_path__ + "138d87ae0a0d0e960addffe715e1e2e7.svg";